import { render, staticRenderFns } from "./galeria-multimedia-album-imagen.vue?vue&type=template&id=7d07493c&scoped=true"
import script from "./galeria-multimedia-album-imagen.vue?vue&type=script&lang=js"
export * from "./galeria-multimedia-album-imagen.vue?vue&type=script&lang=js"
import style0 from "./galeria-multimedia-album-imagen.vue?vue&type=style&index=0&id=7d07493c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d07493c",
  null
  
)

export default component.exports